import { css, type SerializedStyles } from '@emotion/react'
import { rem, size } from 'polished'

import { type IllustrationSize } from './BaseIllustration.types'
import { getSize } from './BaseIllustration.utils'

export const illustration = (illustrationSize: IllustrationSize): SerializedStyles =>
  css(size(rem(getSize(illustrationSize))))
